import React, { useState, useEffect } from "react";
import "./buynowaddress.css";
import "../../components/manageAddress/manageaddress.css";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
import { baseURL } from "../../constants/url";
import { useLocation } from "react-router-dom";
import OrderSummaryDetails from "../../components/orderSummaryDetails/OrderSummaryDetails";

const BuyNowAddress = () => {
  const [show, setShow] = useState(false);
  const [selectedOption, setSelectedOption] = useState("home");
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [showOrderSummary, setShowOrderSummary] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [deletingId, setDeletingId] = useState(null);
  const location = useLocation();
  const product = location.state?.product;
  const variant = product?.variants?.[0] || {};

  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    alternate_phone_number: "",
    pincode: "",
    locality: "",
    area: "",
    city: "",
    state: "",
    landmark: "",
    address_type: "home",
    user: localStorage.getItem("userId") || 1,
  });

   document.querySelectorAll("input").forEach((input) => {
      if (input.value.trim() !== "") {
        input.classList.add("filled");
      }

      input.addEventListener("input", () => {
        if (input.value.trim() !== "") {
          input.classList.add("filled");
        } else {
          input.classList.remove("filled");
        }
      });
    });
    
  useEffect(() => {
    fetchAddresses();
    
  }, []);

    //  ADD THESE (SET YOUR VALUES HERE)
  const platformFee = 8;        
  const deliveryCharge = 49;     

  const productPrice = Number(variant?.final_price || 0);

  const finalAmount =  productPrice + platformFee + deliveryCharge;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormErrors({ ...formErrors, [name]: "" });
  };

  const handleAddressTypeChange = (e) => {
    const value = e.target.value;
    setSelectedOption(value);
    setFormData({ ...formData, address_type: value });
  };
  
  const validateForm = () => {
    const errors = {};
    if (!formData.name) errors.name = "Name is required";
    if (!formData.phone_number || !/^[6-9]\d{9}$/.test(formData.phone_number))
      errors.phone_number = "Valid 10-digit phone number is required";
    if (!formData.pincode || !/^\d{6}$/.test(formData.pincode))
      errors.pincode = "Valid 6-digit pincode is required";
    if (!formData.locality) errors.locality = "Locality is required";
    if (!formData.area) errors.area = "Address is required";
    if (!formData.city) errors.city = "City is required";
    if (!formData.state) errors.state = "State is required";
    return errors;
  };

  const fetchAddresses = async () => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(`${baseURL}common/addresses/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAddresses(res.data);
    } catch (error) {
      console.error("Failed to fetch addresses:", error);
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: error.response?.data?.message || "Failed to fetch addresses.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    setIsLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      await axios.post(`${baseURL}common/addresses/`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      Swal.fire({
        icon: "success",
        title: "Address Saved",
        text: "Address saved successfully!",
        confirmButtonText: "OK",
      });
      setShow(false);
      setFormData({
        name: "",
        phone_number: "",
        alternate_phone_number: "",
        pincode: "",
        locality: "",
        area: "",
        city: "",
        state: "",
        landmark: "",
        address_type: "home",
        user: localStorage.getItem("userId") || 1,
      });
      fetchAddresses();
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to save address.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this address?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    setDeletingId(id);
    setIsLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      await axios.delete(`${baseURL}common/addresses/${id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      Swal.fire({
        icon: "success",
        title: "Address Deleted",
        text: "Address deleted successfully!",
        confirmButtonText: "OK",
      });

      if (selectedAddressId === id) {
        setSelectedAddressId(null);
        setShowOrderSummary(false);
      }
      fetchAddresses();
    } catch (error) {
      console.error("Failed to delete address:", error);
      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text: error.response?.data?.message || "Failed to delete address.",
      });
    } finally {
      setIsLoading(false);
      setDeletingId(null);
    }
  };

  const handleDeliveryHere = (addressId) => {
    setSelectedAddressId(addressId);
    setShowOrderSummary(true);
  };
 
  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="card_common mt_20">
                <button
                  type="button"
                  className="common_btn_all"
                  onClick={() => setShow(!show)}
                  disabled={isLoading}
                >
                  <AddIcon /> ADD A NEW ADDRESS
                </button>

                {show && (
                  <div className="pl_40 pt_40 pb_40">
                    <div className="heading_common mt_15">
                      <h3>Delivery Address</h3>
                    </div>
                    <form onSubmit={handleSubmit} className="manage_addresss">
                      {[
                        ["name", "Name"],
                        ["phone_number", "Phone Number"],
                        ["pincode", "Pin Code"],
                        ["locality", "Locality"],
                        ["area", "Address"],
                        ["city", "City/District/Town"],
                        ["state", "State"],
                        ["landmark", "Landmark (Optional)"],
                        ["alternate_phone_number", "Alternate Phone Number"],
                      ].map(([field, label]) => (
                        <div
                          className={["area"].includes(field) ? "inputSection" : "inputSectionSplit"}
                          key={field}
                        >
                          <input
                            type="text"
                            name={field}
                            value={formData[field]}
                            onChange={handleInputChange}
                            disabled={isLoading}
                          />
                          <label className="inputLabel">{label}</label>
                          {formErrors[field] && (
                            <span className="error" style={{ color: "red", fontSize: "12px" }}>
                              {formErrors[field]}
                            </span>
                          )}
                        </div>
                      ))}

                      <div className="color_grayDark">
                        <p>Address Type</p>
                        <div className="d_flex align_center gap_20">
                          {["Wome", "Work"].map((type) => (
                            <label key={type} className="d_flex align_center gap_5">
                              <input
                                type="radio"
                                value={type}
                                checked={selectedOption === type}
                                onChange={handleAddressTypeChange}
                                disabled={isLoading}
                              />
                              {type.charAt(0).toUpperCase() + type.slice(1)}
                            </label>
                          ))}
                        </div>
                        <div className="mb_20">
                          <button type="submit" className="saveForm" disabled={isLoading}>
                            {isLoading ? "Saving..." : "Save"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                )}

                {isLoading && <p>Loading addresses...</p>}
                {!isLoading && addresses.length > 0 ? (
                  addresses.map((addr) => (
                    <div
                      key={addr.id}
                      className={`address_set mt_20 padd_10 border_gray ${selectedAddressId === addr.id ? "selected" : ""}`}
                    >
                      <div className="address_set_in">
                        <div className="d_flex gap_15">
                          <div className="mt_15">
                            <input
                              type="radio"
                              name="selectedAddress"
                              value={addr.id}
                              className="delivery_add_radio"
                              checked={selectedAddressId === addr.id}
                              onChange={() => {
                                setSelectedAddressId(addr.id);
                                setShowOrderSummary(false);
                              }}
                              disabled={isLoading}
                            />
                          </div>
                          <div className="widthFull">
                            <div className="d_flex align_center justify_sp_between">
                              <span className="address-type text_capitalize">{addr.address_type} </span>
                              <div className="edit_delete_address">
                                <button
                                  type="button"
                                  className="cross_btn"  
                                  onClick={() => handleDelete(addr.id)}
                                  disabled={isLoading}
                                >
                                  {deletingId === addr.id ? "Removing..." : <DeleteIcon />}
                                </button>
                              </div>
                            </div>
                            <div className="address_set_in_print">
                              <h6>{addr.name} {addr.phone_number}</h6>
                              <p>
                                {addr.area}, {addr.locality}, {addr.city}, {addr.state} - {addr.pincode}
                                {addr.landmark ? `, Landmark: ${addr.landmark}` : ""}
                              </p>
                              {selectedAddressId === addr.id && (
                                <button
                                  className="add-cart-btn mt_15"
                                  onClick={() => handleDeliveryHere(addr.id)}
                                  disabled={isLoading}
                                >
                                  Delivery Here
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  !isLoading && <p className="mt_20">No address found.</p>
                )}
              </div>

              {showOrderSummary && (
                <OrderSummaryDetails selectedAddressId={selectedAddressId} />
              )}
            </div>

            <div className="col-lg-4 pt_25">
              {showOrderSummary && product && (
                <div className="card_common2 mt_20">
                  <div className="border_bottom pl_30 pr_30 pt_20">
                    <h6>Price Details</h6>  
                  </div>
                  <div className="pl_30 pr_30 pt_20 pb_30">
                    <div className="d_flex justify_sp_between pb_10">
                      <p>Price</p>
                      <p>₹{productPrice}</p>
                    </div>
                    <div className="d_flex justify_sp_between pb_10">
                      <p>Platform Fee: </p>
                      <p>₹{platformFee}</p>
                    </div>
                    <div className="d_flex justify_sp_between pb_10">
                      <p>Delivery Charge: </p>
                      <p>₹{deliveryCharge}</p>
                    </div>
                     <div className="d_flex justify_sp_between pb_10">
                      <p>Discount</p>
                      <p className="color_green">₹{variant.discount_percent}% </p>
                    </div>  
                    <div className="border_bottom_dash border_top_dash">
                      <div className="d_flex justify_sp_between pt_10 pb_10">
                        <p className="font_bold">Total Payble Amount</p>
                        <p className="font_bold">₹{finalAmount}</p>
                      </div>
                    </div>
                    <div className="pt_15">
                      <p className="color_green">
                        You will save ₹ ({variant.discount_percent}% Off) on this order
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
      <Subscribe />
      <Footer />
    </>
  );
};

export default BuyNowAddress;
